/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const SupportPlanPost = {
  id: 'support-plan.post',
  tag: 'Support',
  summary: 'Support plan create',
  description: 'Support plan create',
  method: 'post',
  flags: { isSuperuser: true, isAuthorized: true },
  route: () => `/support-plans`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            name: z.string(),
            description: z.string(),
            price: z.number(),
            isDefault: z.boolean().optional(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            id: z.string(),
            name: z.string(),
            description: z.string(),
            price: z.number(),
            createdAt: z.date().optional(),
            updatedAt: z.date().optional(),
            isDefault: z.boolean().optional(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
